<form [formGroup]="bulkLotForm">
  <div class="row">
    <ng-content select=".lotType"></ng-content>

    <div class="col-md-12">
      <div class="form-group">
        <label class="form-label mb-0">Lot Number *</label>
        <mat-form-field appearance="outline">
          <input
            matInput
            formControlName="lotNumber"
            [maxlength]="fieldLengthShorter"
            [disabled]="lotId"
            [readonly]="lotId"
          />
        </mat-form-field>
        <control-messages
          [isFormSubmitted]="submitting"
          [control]="bulkLotForm.controls.lotNumber"
        ></control-messages>
      </div>
    </div>

    <div class="col-md-12">
      <div class="form-group">
        <mat-label>{{
          isClosingBegin ? "Added Lots *" : "Select Lots to Add to Bulk Lot *"
        }}</mat-label>
        <ng-container *ngIf="!isClosingBegin">
          <mat-form-field appearance="outline">
            <input
              matInput
              formControlName="searchLot"
              [maxlength]="fieldLengthShorter"
              [matAutocomplete]="auto"
              [disabled]="isClosingBegin"
            />
          </mat-form-field>
          <mat-hint
            [ngClass]="{ 'error-msg': submitting }"
            *ngIf="selectedLots && selectedLots?.length < minimumLotsToBeAdd"
            >Atleast {{ minimumLotsToBeAdd }} lots are required for bulk
            lot</mat-hint
          >
          <control-messages
            [isFormSubmitted]="submitting"
            [control]="bulkLotForm.controls.searchLot"
          >
          </control-messages>
          <mat-autocomplete
            #auto="matAutocomplete"
            (optionSelected)="selected($event)"
          >
            <ng-container *ngFor="let lot of filteredLots | async">
              <mat-option *ngIf="!lot.selected" [value]="lot">
                {{ lot.text }}
              </mat-option>
            </ng-container>
          </mat-autocomplete>
        </ng-container>

        <mat-chip-list>
          <mat-chip *ngFor="let lot of selectedLots; index as lotIndex">
            {{ "Lot " + lot.text.split("/")[0] }}
            <mat-icon
              matChipRemove
              *ngIf="!isClosingBegin"
              role="button"
              (click)="removeLot(lot, lotIndex)"
              >cancel</mat-icon
            >
          </mat-chip>
        </mat-chip-list>
      </div>
    </div>

    <div class="col-md-12">
      <div class="form-group">
        <label class="form-label mb-0">Description *</label>
        <mat-form-field appearance="outline">
          <textarea
            matInput
            formControlName="description"
            [maxlength]="fieldLengthLonger"
          ></textarea>
        </mat-form-field>
        <control-messages
          [isFormSubmitted]="submitting"
          [control]="bulkLotForm.controls.description"
        ></control-messages>
      </div>
    </div>

    <div class="col-md-12">
      <div class="form-group">
        <label class="form-label mb-0">Location *</label>
        <mat-form-field appearance="outline">
          <input
            matInput
            placeholder="Enter Location"
            formControlName="location"
            [maxlength]="fieldLength"
          />
        </mat-form-field>
        <control-messages
          [isFormSubmitted]="submitting"
          [control]="bulkLotForm.controls.location"
        ></control-messages>
      </div>
    </div>

    <div class="col-md-12">
      <div class="form-group">
        <label class="form-label mb-0">Lot Category *</label>
        <mat-form-field appearance="outline">
          <input
            matInput
            type="text"
            placeholder="Enter Lot Category"
            formControlName="category"
            [maxlength]="fieldLength"
          />
        </mat-form-field>
        <control-messages
          [isFormSubmitted]="submitting"
          [control]="bulkLotForm.controls.category"
        ></control-messages>
      </div>
    </div>

    <div class="col-md-12">
      <div class="form-group">
        <label class="form-label mb-0">Consignor</label>
        <mat-form-field appearance="outline">
          <input
            matInput
            type="text"
            placeholder="Enter Consignor"
            formControlName="consignor"
            [maxlength]="fieldLength"
          />
        </mat-form-field>
        <control-messages
          [isFormSubmitted]="submitting"
          [control]="bulkLotForm.controls.consignor"
        ></control-messages>
      </div>
    </div>

    <div class="col-md-12">
      <div class="form-group">
        <label class="form-label mb-0">Starting/Opening Price</label>
        <mat-form-field appearance="outline">
          <input
            matInput
            type="number"
            placeholder="Enter Starting/Opening price"
            formControlName="startingPrice"
            [min]="minAmount"
            [max]="maxAmount"
          />
        </mat-form-field>
        <control-messages
          [isFormSubmitted]="submitting"
          [control]="bulkLotForm.controls.startingPrice"
        ></control-messages>
      </div>
    </div>

    <div class="col-md-12">
      <div class="form-group">
        <label class="form-label mb-0">
          Modifier(%) *
          <span
            class="custom-tooltip"
            #tooltip="matTooltip"
            matTooltip="Bulk Buyer Protection: Enter a percentage value to grant protection to a Bulk Bidder or piecemeal bidders. Example: +10% means that a $100,000 bulk bid would require $110,000 in piecemeal bids to overcome. Alternatively, -10% means that a $100,000 bulk bid would require just 90,000 of piecemeal bids to overcome."
          >
            <img alt="info" src="../assets/images/info.svg" />
          </span>
        </label>
        <div>
          value :
          {{
            bulkLotForm.value.modifier ? bulkLotForm.value.modifier + "%" : 0
          }}
        </div>
        <mat-slider
          class="w-75"
          value="0"
          [max]="maxModifier"
          [min]="minModifier"
          [step]="steps"
          [thumbLabel]="label"
          [tickInterval]="tickIntervals"
          [disabled]="isClosingBegin"
          formControlName="modifier"
        >
        </mat-slider>
        <control-messages
          [isFormSubmitted]="submitting"
          [control]="bulkLotForm.controls.modifier"
        >
        </control-messages>
      </div>
    </div>
  </div>

  <p class="error-msg my-2" *ngIf="bulkLotForm.invalid && submitting">
    Please resolve error(s) first
  </p>

  <div class="image-popup-wrap pt-2 mt-2">
    <ng-content select=".closeModalButton"></ng-content>

    <ng-container *ngIf="!lotId">
      <button
        type="submit"
        [disabled]="publishLoading || loading"
        class="btn btn-colored font-15 ml-2"
        role="button"
        (click)="bulkLotFormSubmit(false)"
      >
        <span
          *ngIf="loading"
          class="spinner-border spinner-border-sm mr-1"
        ></span>
        {{ lotId ? "Update" : "Add" }} Bulk Lot
      </button>
    </ng-container>

    <ng-container *ngIf="lotId">
      <button
        type="submit"
        [disabled]="loading || publishLoading"
        class="btn btn-colored font-15 ml-2"
        role="button"
        (click)="bulkLotFormSubmit(true)"
      >
        <span
          *ngIf="publishLoading"
          class="spinner-border spinner-border-sm mr-1"
        ></span>
        {{ lotId ? "Update" : "Add" }} Bulk Lot & Publish
      </button>
    </ng-container>
  </div>
</form>
